module.exports = __webpack_public_path__ + "media/images/icons/spinner-75e4ff56871120c8d0391cdb667d8d5e.svg";